import { useModal } from 'components/Modal';
import { useMutation } from 'query';
import { reject } from 'scenes/FinancePage/IO/data/queryKeyFactory';
import { rejectIO } from 'scenes/FinancePage/IO/sources';

import ConfirmDialog from './components/ConfirmDialog';

export const useReject = () => {
  const [showConfirmDialog] = useModal(ConfirmDialog);

  const approveMutation = useMutation(reject(), rejectIO, {
    refresh: true,
    successMessage: () => 'IO rejected',
  });

  const handleAction = ({
    id,
    businessPartner,
    period,
    createdBy,
    parentIo,
  }: any) => {
    showConfirmDialog({
      modalTitle: 'Reject',
      businessPartner,
      period,
      createdBy,
      parentIo,
    }).then(({ comment, reasons }: { comment: string; reasons: number[] }) =>
      approveMutation.mutateAsync({ id, comment, reasons })
    );
  };

  return [handleAction, approveMutation];
};
